<template>
    <div class="rv-create p-0">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Sửa sản phẩm
        </div>
        <div :class="{
                'body': true,
                'p-3': $detect == 'web'
            }">
            <imageEdit
                :data.sync="form.data_gallery"
                :pictureMain.sync="form.picture1"
                :error.sync="error.data_gallery"
                :errorPicture.sync="error.picture1"
                :exclusive.sync="exclusive"/>
            <titleCreate
                :data.sync="form.name"
                :error.sync="error.name"/>
            <category
                :suggest="suggestCategory"
                :data.sync="form.category"
                :error.sync="error.category"
                :title="form.name"
                :namecat="catName"
                :check="checkChangeCategory"
                />
            <priceCreate :data.sync="form.price"/>
            <vat :data.sync="form.vat" />
            <div class="d-flex">
                 <unit 
                 class="w-50"
                    :data.sync="form.unit"
                    :error.sync="error.unit"/>
                <minQuantity   class="w-50" :data.sync="form.minQuantity"  :error.sync="error.minQuantity"/>
            </div>
            <callBuy :data.sync="form.quantity"/>
            <div class="d-flex product">
                <typeCreate :data.sync="form.type"/>
                <newOld :data.sync="form.quality"/>
            </div>
            <warranty :data.sync="form.warranty"/>
            <website :data.sync="form.website"/>
            <origin :data.sync="form.origin"
                    :error.sync="error.origin"/>
            <otherInfo :data.sync="form.otherInfo"/> 
            <sizeColor v-if="arrSizeColor.color && arrSizeColor.size && arrSizeColor.color.length > 0 && arrSizeColor.size.length > 0 || form.size_color && form.size_color.length > 0" :sizecolor="arrSizeColor" :data.sync="form.size_color" />
            <div class="mt-4 content">
                <p class="mb-2 fs-14px">Nội dung:</p>
                <editor :content.sync="form.description"/>
                <p class="mb-0 fs-14px text-note-img mt-1">* Nhập nội dung đầy đủ, đa dạng thì bài đăng sẽ xuất hiện ở nhiều công cụ tìm kiếm và người dùng dễ dàng tiếp cận hơn.</p>
                <div class="text-danger fs-12px mt-1" v-if="error.description">{{error.description}}</div>
            </div>
            <div style="height: 80px;" v-if="$detect == 'mobile'"></div>
            <div :class="{
                    'confirm mt-4 text-center': true,
                    'p-3 confirm-mobile fixed-bottom bg-white': $detect == 'mobile'
                }">
                <button type="button" class="btn btn-primary"
                    :disabled="loading" @click="submit()">Cập nhật</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        category: () => import('@/components/profile/create/categoryPro.vue'),
        city: () => import('@/components/profile/create/city.vue'),
        editor: () => import('@/components/editor/index'),
        imageEdit: () => import('@/components/profile/product/edit/image'),
        titleCreate: () => import('@/components/profile/create/title'),
        unit: () => import('@/components/profile/create/unit'),
        minQuantity: () => import('@/components/profile/create/minQuantity'),
        addressCreate: () => import('@/components/profile/create/address'),
        priceCreate: () => import('@/components/profile/create/price'),
        typeCreate: () => import('@/components/profile/create/source'),
        newOld: () => import('@/components/profile/create/quality'),
        warranty : () => import('@/components/profile/create/warranty'),
        website : () => import('@/components/profile/create/website'),
        vat : () => import('@/components/profile/create/vat'),
        callBuy : () => import('@/components/profile/create/callBuy'),
        sizeColor : () => import('@/components/profile/create/sizeColor'),
        otherInfo : () => import('@/components/profile/create/otherInfo'),
        origin : () => import('@/components/profile/create/origin'),

    },
    data() {
        return {
            imgPrimary: false,
            catName: '',
            id: this.$route.params.id,
            exclusive : null,
            iCat : 0,
            form: {
                name: '',
                category: '',
                description: '',
                unit: '',
                city: '',
                type: 1,
                minQuantity: 0,
                price: '',
                picture1: '',
                data_gallery: [],
                quality : 0,
                warranty: 0,
                website : '',
                otherInfo: '',
                vat : 1,
                origin : 14,
                quantity : 1,
                size_color: [
                    {
                        color : null,
                        size : null,
                        price : null,
                        quantity  : null,
                        picture : null,
                    }
                ],
            },
            checkChangeCategory: true,
            arrSizeColor : [],
            error: {},
            suggestCategory: [],
            loading: false,
        }
    },
    created() {
        this.$store.state.title = 'Sửa sản phẩm';
        apiGet('/v2/products/get_suggest_category').then(res => {
            let data = res.data;
            this.suggestCategory = data.category;
        })
        apiGet('/v2/products/get_product',{iPro : this.id}).then(res => {
            let product = res.data;
            this.form.name = product.name;
            this.form.description = product.description;
            this.form.unit = product.unit;
            this.form.type = product.type;
            this.form.minQuantity = product.minQuantity;
            this.form.quality = product.quality;
            this.form.warranty = product.warranty;
            this.form.website = product.website;
            this.form.price = product.price;
            this.form.vat = product.vat;
            this.form.quantity = product.quantity;
            this.form.category = product.cat_id;
            this.catName     =   product.cat_name;
            this.form.picture1 = res.picture_main;
            this.form.data_gallery = res.data_gallery;
            this.form.size_color   = res.arrSizeColor;
            this.form.otherInfo    = product.other_info;
            this.exclusive         = product.exclusive;
            this.iCat              = product.cat_id;
            this.form.origin            = product.origin;
            // this.checkChangeCategory = product.checkChangeCategory;

            this.checkChangeCategory = true;
            // if(res.arrSizeColor.length > 0){
            //     this.getSizeColor(product.cat_id);
            // }
        })
    },
    watch : {
        'form.category'(value){
            if(value != ""){
                this.getSizeColor(value);
                this.changeCategory(value);
            }
        }
    },
    methods: {
        getSizeColor(iCat){
             apiGet('/v2/profile/products/load_category_size_color', {
                    iCat: iCat
                }).then(res => {
                    this.arrSizeColor = res.data;
                })
        },
        async submit(){
            if(this.loading) return;
            this.loading = true;
            this.error = {};
            let form = {};
            form.name = this.form.name;
            form.iCat = this.form.category;
            form.description = this.form.description;
            form.unit = this.form.unit;
            form.min_quantity = this.form.minQuantity;
            form.type = this.form.type;
            form.quality = this.form.quality;
            form.warranty = this.form.warranty;
            form.website = this.form.website;
            form.vat = this.form.vat;
            form.origin = this.form.origin;
            form.quantity = this.form.quantity;
            form.price = this.$stringToNumber(this.form.price);
            form.iPro  = this.id;
            form.other_info = this.form.otherInfo;
            if(this.form.picture1){
                form.picture = this.form.picture1;
            }else{
                if(this.form.data_gallery.length > 0){
                    form.picture = this.form.data_gallery[0].filename;
                }
            }
            form.size_color = [];
            form.size_color_old= [];
            var occ = {};
            this.form.size_color = this.form.size_color.filter(function(x) {
                if (occ[x.size] && occ[x.color]) return false;
                occ[x.size] = true;
                occ[x.color] = true;
                return true;
            })

            this.form.size_color.map(item => {
                if(!item.pscd_psci_id && item.size != null){
                    form.size_color.push({
                        color : item.color,
                        size : item.size,
                        price : this.$stringToNumber(item.price),
                        quantity  : Number(item.quantity),
                        picture : 0
                    });
                }else{
                     form.size_color_old.push({
                        color : item.color,
                        size : item.size,
                        price : item.price,
                        quantity  : Number(item.quantity),
                        picture : 0
                    });
                }
            })
            
           
            form.gallery = [];
            this.form.data_gallery.map(item => {
                if(!item.gallery_id){
                    form.gallery.push({
                        name: item.filename,
                        width: item.width,
                        height: item.height
                    });
                }
            });
            if(this.iCat != this.form.category && form.size_color_old.length > 0 && form.size_color_old.size != null ){
                this.error = {category : 'Bạn phải xóa Màu sắc và kích thước cũ đi trước khi thay đổi danh mục'};
                this.$message({
                    message: 'Vui lòng kiểm tra lại các trường',
                    type: 'warning',
                    center: true,
                });
            }else{
                await apiPut('/v2/profile/products/edit', {form}).then(res => {
                    if(res.data.status == 1){
                        this.$message({
                            message: 'Cập nhật sản phẩm thành công!',
                            type: 'success',
                            center: true,
                        });
                        this.$router.push({
                            name: 'product-create-step2',
                            params: {
                                id: this.id
                            }
                        })
                    }else{
                        this.error = res.data.msg;
                        this.$message({
                            message: 'Vui lòng kiểm tra lại các trường',
                            type: 'warning',
                            center: true,
                        });
                    }
                }).catch(err => {
                    if(err.status == 422){
                        this.error = err.data;
                        this.$message({
                            message: 'Vui lòng kiểm tra lại các trường',
                            type: 'warning',
                            center: true,
                        });
                    }
                });
            }
            this.loading = false;
        },
        changeCategory(iCat){
            apiPost('v2/products/change_category', {
                    iCat: iCat,
                    iPro: this.id
                }).then(res => {
                    console.log(res)
                }).catch(err => {
                    console.log(err)
                    // if(err.status == 422){
                    //     this.error = err.data.data;
                    //     this.$message({
                    //         message: 'Vui lòng kiểm tra lại các trường',
                    //         type: 'warning',
                    //         center: true,
                    //     });
                    // }
                });
        }
    }
};
</script>
<style lang='scss'>
    .box-btn-x{
         width: calc(50% - 4px);
    }
    .btn_rdo{
        display: inline-block;
        background: #ccc;
        border-radius: 3px;
        color: #fff;
        height: 50px;
        line-height: 48px;
        opacity: 1;
        text-align: center;
        /*width: calc(50% - 4px);*/
        width: 110px;
        border: 1px solid #ccc;
        transition: all .3s;
        box-sizing: border-box;
        position: relative;
        font-weight: 700;
        margin-top: 0;
        font-size: 16px;
        &.btn_rdo_call{
            background: #33a837;
            border: 1px solid #33a837;
        }
        &.btn_rdo_buy{
            background: #f44f00;
            border: 1px solid #f44f00;
        }
    }
    .call-or-buy{
        padding: 11px 0;
        /*border-radius: 4px;*/
        border-top: 1px solid #007bff;
        /*border-bottom: 1px solid #007bff;*/


        .buy-call{
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
            color: #007bff;
        }
    }
    .product{
        .type{
            width: calc(50% - 4px);
        }
    }
    .min-quantity,.unit, .quality{
        width: calc(50% - 4px);

    }
    .min-quantity,.quality {
        margin-left: 8px;
    }
    input {
        box-shadow: none !important;
        -webkit-appearance: none;
    }
    .rv-create {
        .body {
            .confirm {
                button {
                    padding: 8px 60px !important;
                }
            }
            .confirm-mobile {
                box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -2px 4px rgba(0,0,0,0.12);
                button {
                    width: 100%;
                }
            }
        }
    }
    .rv-valiadate-input-form {
        input {
            border: 1px solid #dc3545 !important;
        }
        label {
            color: #dc3545 !important;
        }
    }
    .input-focus-effect {
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        input {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
            &:focus {
                border-color: #007bff;
            }
            &:focus + label {
                transform: translateY(0);
                top: -13px;
                color: #007bff;
                background: #fff;
                padding: 0 10px;
                font-size: 14px;
                margin-left: -5px;
            }
        }
        label {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            pointer-events: none;
            color: #999;
            transition: 0.15s linear;
            font-size: 16px;
        }
        .input-on-alue {
            transform: translateY(0) !important;
            top: -13px !important;
            color: #007bff !important;
            background: #fff !important;
            padding: 0 10px !important;
            font-size: 14px !important;
            margin-left: -5px !important;
        }
    }
</style>
